<template>
  <span>
    <span class="verbose">
      <span class="bold"
        >{{ currentPageRangeStart }} - {{ currentPageRangeEnd }} </span
      >{{ ofString }} {{ itemCount }} {{ itemDescription }}
    </span>
    <span class="succinct"
      >{{ pageString }} {{ currentPage }} {{ ofString }} {{ pages }}</span
    >
  </span>
</template>

<script>
export default {
  name: "PaginationIndicator",
  props: {
    /**
     * @vuese
     * Current page number
     */
    currentPage: {
      type: Number,
      required: true,
    },
    // Indicate the starting item index within this page
    currentPageRangeStart: {
      type: Number,
      required: true,
    },
    // Indicate the ending item index in this page
    currentPageRangeEnd: {
      type: Number,
      required: true,
    },
    // Total number of pages
    pages: {
      type: Number,
      required: true,
    },
    // Total number of items across pages
    itemCount: {
      type: Number,
      required: true,
    },
    // The equivalent of the english 'of' word.
    ofString: {
      type: String,
      default: "of",
    },
    // The equivalent of the english 'Page' word.
    pageString: {
      type: String,
      default: "Page",
    },
    // The translated word that describes the items displayed in the table. E.g. 'reports'.
    itemDescription: {
      type: String,
      default: "items",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~include-media";

.verbose {
  @include media("<tablet") {
    display: none;
  }
  .bold {
    font-weight: 700;
  }
}

.succinct {
  @include media(">=tablet") {
    display: none;
  }
}
</style>
